import type { ChartMetadataT } from 'modules/decision/types/explore';
import { createContext, useContext } from 'react';

const ChartMetadataContext = createContext<ChartMetadataT | undefined>(
    undefined,
);

export const ChartMetadataProvider = ChartMetadataContext.Provider;
export const useChartMetadataContext = () => useContext(ChartMetadataContext);
